import axios, { AxiosInstance } from 'axios';
import store from '../store/store';
import { setAccessToken, clearAccessToken, setMustChangePassword } from '../views/auth/reducer';

/**
 * Uma renovação por vez (`BUG-024`): N requisições que levam 401 juntas esperam o MESMO refresh.
 * Sem isso, cada uma disparava o seu, e a tela inteira fazia 5 a 16 refreshes no mesmo segundo.
 */
let refreshEmAndamento: Promise<string> | null = null;

const renovarToken = (): Promise<string> => {
  if (!refreshEmAndamento) {
    refreshEmAndamento = axios
      .post(`${process.env.REACT_APP_BACKEND_URL}/auth/refresh`, {}, { withCredentials: true })
      .then((response) => response.data.token as string)
      .finally(() => {
        refreshEmAndamento = null;
      });
  }
  return refreshEmAndamento;
};

const attachAuthToken = (instance: AxiosInstance) => {
  instance.interceptors.request.use((config) => {
    const token = localStorage.getItem('authToken');
    if (token) {
      config.headers = config.headers ?? {};
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  });

  instance.interceptors.response.use(
    (response) => response,
    async (error) => {
      const originalRequest = error.config;
      const isAuthEndpoint = originalRequest?.url?.includes('/auth/');

      if (
        error.response?.status === 403 &&
        error.response?.data?.message === 'PASSWORD_CHANGE_REQUIRED'
      ) {
        store.dispatch(setMustChangePassword(true));
        return Promise.reject(error);
      }

      if (error.response?.status === 401 && !isAuthEndpoint && !originalRequest?._retry) {
        originalRequest._retry = true;

        try {
          const newToken = await renovarToken();
          localStorage.setItem('authToken', newToken);
          store.dispatch(setAccessToken(newToken));
          originalRequest.headers['Authorization'] = `Bearer ${newToken}`;

          return instance(originalRequest);
        } catch {
          localStorage.removeItem('authToken');
          store.dispatch(clearAccessToken());
          window.location.href = '/login';
        }
      }

      return Promise.reject(error);
    },
  );
};

export default attachAuthToken;
